
export default function DifferentiatorSection() {
  return (
    <section className="py-20 bg-primary text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            A União da Experiência
          </h2>
          <h3 className="text-2xl md:text-3xl font-semibold mb-8 text-accent">
            Visão Interna + Expertise Externa
          </h3>
          <p className="text-lg md:text-xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            A LicitMax nasce da integração de mais de 10 anos de experiência prática na Administração Pública com uma atuação jurídica técnica e responsável. Esse olhar completo nos permite compreender a lógica dos processos licitatórios e apoiar sua empresa com orientação segura, estratégica e resultados consistentes.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-16">
          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-lg border border-white/20">
            <div className="w-16 h-16 flex items-center justify-center bg-accent rounded-lg mb-6">
              <i className="ri-government-line text-3xl text-primary"></i>
            </div>
            <h4 className="text-2xl font-semibold mb-4">Experiência Interna</h4>
            <p className="text-white/80 leading-relaxed">
              Conhecimento sólido dos processos internos da Administração Pública, com compreensão clara e prática de cada etapa sob a ótica de quem atua dentro do poder público.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm p-8 rounded-lg border border-white/20">
            <div className="w-16 h-16 flex items-center justify-center bg-accent rounded-lg mb-6">
              <i className="ri-briefcase-line text-3xl text-primary"></i>
            </div>
            <h4 className="text-2xl font-semibold mb-4">Expertise Externa</h4>
            <p className="text-white/80 leading-relaxed">
              Unimos expertise jurídica especializada à atuação operacional da consultoria para conduzir sua empresa nas licitações com segurança e estratégia
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
